import React, { useState, useEffect, useContext } from "react";
import Layout from "../../components/Layout/Layout";
import { db } from "../../firebase/firebase-config";
import { useAuthState } from 'react-firebase-hooks/auth';
import { collection, query, where, getDocs, getDoc, deleteDoc, doc } from "firebase/firestore";
import { Table, Input, Select } from 'antd';
import { auth } from '../../firebase/firebase-config';
import BeatLoader from "react-spinners/BeatLoader";
// import BpCaseModal from "../../components/ui/BpCaseModal/BpCaseModal";
import "tippy.js/dist/tippy.css";
import { ConfirmModal } from "../../components";
import ChartModal from "./chart-modal/ChartModal";
import DataTable from "./table/DataTable";
import moment from 'moment';
import SubModal from "./SubModal/SubModal";
import { toast } from "react-toastify";
import EditPlansModal from "./EditPlanModal/EditPlanModal";

const { Search } = Input;


const override = {
  marginTop: "20px",
};


function Index() {
  const [allSubData, setAllSubData] = useState<any[]>([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [activeEditItem, setActiveEditItem] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [currentActiveCase, setCurrentActiveCase] = useState(null);

  const [searchText, setSearchText] = useState<string>('');
  const [filteredData, setFilteredData] = useState<any[]>(allSubData);

  const [activeUserData, setActiveUserData] = useState(null);
  const [showLiveChart, setShowLiveChartModal] = useState(false);
  const [showCreateReadingsModal,setShowCreateReadingsModal] = useState(false);


  const [showConfirmodal, setShowConfirmModal] = useState(false);
  const [currentActiveId, setCurrentActiveId] = useState();

  const [user] = useAuthState(auth);


  const [loading, setLoading] = useState(false);

  const deletePlan = async () => {
    console.log('DELETE PLAN')
      // LOGIC TO DELETE SPECIALITY
      const docRef = doc(collection(db,"Plans"),currentActiveId)

      await deleteDoc(docRef).then(() => {
        toast.success('Plan Deleted', {
          pauseOnHover: false,
          closeOnClick: true,
        });
        fetchData();
        setShowConfirmModal(false);
      })


  }

  const toggleAddModal = () => {
    setShowCreateModal(!showCreateModal);
  };

  const toggleEditModal = () => {
    setShowEditModal(!showEditModal);
  };
  const toggleReadingsModal = () => {
    setShowCreateReadingsModal(!showCreateReadingsModal);
  }

  const handleContentAdded = () => {
    setShowCreateModal(false);
    setShowCreateReadingsModal(false);
    //FETCH DATA
    fetchData();
  };

  const handleContentUpdated = () => {
    setShowEditModal(false);
    //FETCH DATA
    fetchData();
  };

  const fetchData = async () => {
    setLoading(true);
    const querySnapshot = await getDocs(collection(db, "Plans"));
    const subData: any = [];

    querySnapshot.forEach((doc) => {
      subData.push({
        id: doc.id,
        ...doc.data()
      })
    });

    // console.log('SORTED DATA: ', subData);

    // const sortedData = subData.sort((a: any, b: any) => {
    //   const momentA = moment(a.createdAt?.seconds * 1000 || a?.createdAt);
    //   const momentB = moment(b.createdAt?.seconds * 1000 || b?.createdAt);
    //   return momentB.diff(momentA);
    // });

    setAllSubData(subData)

    setLoading(false);
  };

  const setActiveCasetData = (data: any) => {
    // console.log('CASE DATA: ', data);
    setCurrentActiveCase(data);
    setShowCreateReadingsModal(true);
  }

  useEffect(() => {
    // console.log('FETCHING: ......')
    fetchData();
  }, []);

  const [sortedInfo, setSortedInfo] = useState<any>({});

  const handleChange = (pagination: any, filters: any, sorter: any) => {
    setSortedInfo(sorter);
  };

  allSubData.forEach((item: any, index: any) => {
    item.index = index + 1;
  });

  useEffect(() => {
    let fillData = filterData(allSubData, searchText);
    setFilteredData(fillData);

  }, [allSubData, searchText]);

  const filterData = (data: any[], query: string) => {
    if (!query) return data;

    return data.filter((item) =>
      Object.values(item).some((value: any) =>
        value?.toString().toLowerCase().includes(query.toLowerCase())
      )
    );
  };


  const handleSearch = (value: string) => {
    setSearchText(value);
  };


  return (
    <>
    <Layout title="Plans" pageTitle="All  Plans">
      <div className="section">
        <div className="parent-con">
          <div className="data-table">
            <div className="top">
              <div className="span">
                <h3>All Plans</h3>
              </div>

              <button 
               onClick={toggleAddModal}
              className="btn btn-primary btn-add student-button">
                New Plan
              </button>
            </div>
            <div className="table-con">
                <div style={{ textAlign: "center" }}>
                  <BeatLoader
                    color="#3080ED"
                    loading={loading}
                    cssOverride={override}
                  />
                </div>
                <Search
                  placeholder="Search for data..."
                  onSearch={handleSearch}
                  onChange={(e) => handleSearch(e.target.value)}
                  value={searchText}
                  style={{ width: 200, marginBottom: 16 }}
                />

                    <DataTable key={allSubData.length} data={filteredData}
                        toggleAddReportModal={() => {}}
                        setCurrentActiveId={setCurrentActiveId}
                        setShowConfirmModal={setShowConfirmModal}
                        setActiveEditItem={setActiveEditItem}
                        setShowEditModal={setShowEditModal}
                    />
              
              </div>
  
          </div>
        </div>
      </div>
    </Layout>

    {showConfirmodal && (
          <ConfirmModal 
              title="Are you sure you want to delete plan ?"
              onAccept={() => deletePlan()}
              onCancel={() => setShowConfirmModal(false)}
          />
      )}

     {showCreateModal && (
      <SubModal
        onContentAdded={handleContentAdded}
        onClose={toggleAddModal}
        setActiveCasetData={setActiveCasetData}
      />
    )}

    {showEditModal && (
      <EditPlansModal
      onContentUpdated={handleContentUpdated}
        onClose={toggleEditModal}
        setActiveCasetData={setActiveCasetData}
        item={activeEditItem}
      />
    )}

    {showLiveChart && (
        <ChartModal user={activeUserData} onCancel={() => setShowLiveChartModal(false)} />
      )}
    </>
  );
}

export default Index;
